import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBd1LH1z2Ur2V4hF48-ZGQiR4fDZjwRwHU",
  authDomain: "kba-association.firebaseapp.com",
  databaseURL: "https://kba-association-default-rtdb.firebaseio.com",
  projectId: "kba-association",
  storageBucket: "kba-association.appspot.com",
  messagingSenderId: "532862425898",
  appId: "1:532862425898:web:ee7ab4f3a438fee93e5c53"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);     // ✅ keep this
const fireDB = db;                // ✅ alias (for signup)
const auth = getAuth(app);        // ✅ for login/signup

// ✅ export ALL (important)
export { db, fireDB, auth };